export default __webpack_public_path__ + "static/media/deliveryfailed.d37e62ab.svg";